import { createFileRoute } from '@tanstack/react-router';

import { getCitationOptions } from '@/module/Author/Citation/model/CitationQuery';

export const Route = createFileRoute(
  '/_auth/author/_author/article/_article/$articleId/_layout/citations/$citationId/_layout',
)({
  loader: async ({ params: { articleId, citationId }, context: { queryClient } }) => {
    const citation = await queryClient.ensureQueryData(getCitationOptions(articleId, citationId));
    return {
      citation,
      breadcrumb: citation?.title ?? '',
    };
  },
});
